import { z } from 'zod'

export const InvoiceStatus = z.enum(['draft', 'open', 'paid', 'void', 'uncollectible'])

export type InvoiceStatus = z.infer<typeof InvoiceStatus>

export const CheckoutResponse = z.object({
  client_secret: z.string().optional(),
  hosted_url: z.string().optional(),
  intent_id: z.string().optional(),
  status: InvoiceStatus.optional()
})

export type CheckoutResponse = z.infer<typeof CheckoutResponse>

// Keep ClientSecret for backwards compatibility
export const ClientSecret = CheckoutResponse
export type ClientSecret = CheckoutResponse
